import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetFinancialYears = createModule({
    base: 'GET_FINANCIAL_YEARS', apiDetails: {...SERVICE_ENDPOINT.FINANCIAL_YEAR, method: 'get'}
})

export {
    GetFinancialYears
}
